module.exports = __webpack_public_path__ + "imgs_icon.39c10b8d.png";